import {
  ELITE_PLANS_ELITE_PRIME_TAB_ID,
  ELITE_PLANS_ELITE_TAB_ID
} from '../../constants/planIds'

const ADVICE_CARD_ICONS_BASE = '/images/elite-plans/advice-cards'

type AdviceCardGlyph =
  | 'clock'
  | 'rebalance'
  | 'piggy-bank'
  | 'regular-to-direct'
  | 'calendar'
  | 'calendar-check'
  | 'check-circle'
  | 'lumpsum'

type AdviceCardIconTheme = 'elite' | 'elite-prime'

const ELITE_ADVICE_CARD_GLYPHS: Record<string, AdviceCardGlyph> = {
  'rebalance-plan': 'rebalance',
  'regular-to-direct-plan': 'regular-to-direct',
  'tax-summary': 'piggy-bank'
}

const ELITE_PRIME_ADVICE_CARD_GLYPHS: Record<string, AdviceCardGlyph> = {
  'rebalance-plan': 'rebalance',
  'allocation-plan': 'clock',
  'ideal-portfolio': 'check-circle',
  'sip-plan': 'calendar',
  'ideal-sip-plan': 'calendar-check',
  'lump-sum-investment-plan': 'lumpsum',
  'regular-to-direct-plan': 'regular-to-direct',
  'tax-summary': 'piggy-bank'
}

/** Cards that are part of Elite (also shown on the Elite Prime tab). */
export function isEliteAdviceCard(cardId: string): boolean {
  return cardId in ELITE_ADVICE_CARD_GLYPHS
}

/**
 * Advice-card icon for the active plan tab. Locked variants have the lock baked into the asset.
 * Elite uses the lighter (elite50) set; Elite Prime the darker (prime50) set.
 */
export function resolveAdviceCardIconSrc(
  cardId: string,
  planId: string,
  locked: boolean
): string | undefined {
  const lockState = locked ? 'locked' : 'unlocked'
  const toSrc = (theme: AdviceCardIconTheme, glyph: AdviceCardGlyph) =>
    `${ADVICE_CARD_ICONS_BASE}/${theme}/${lockState}/${glyph}.svg`

  if (planId === ELITE_PLANS_ELITE_PRIME_TAB_ID) {
    const glyph = ELITE_PRIME_ADVICE_CARD_GLYPHS[cardId]
    return glyph ? toSrc('elite-prime', glyph) : undefined
  }
  if (planId === ELITE_PLANS_ELITE_TAB_ID) {
    const glyph = ELITE_ADVICE_CARD_GLYPHS[cardId]
    return glyph ? toSrc('elite', glyph) : undefined
  }
  // Unknown tab id: prefer the Elite set, fall back to Elite Prime for Prime-only cards
  const eliteGlyph = ELITE_ADVICE_CARD_GLYPHS[cardId]
  if (eliteGlyph) return toSrc('elite', eliteGlyph)
  const primeGlyph = ELITE_PRIME_ADVICE_CARD_GLYPHS[cardId]
  return primeGlyph ? toSrc('elite-prime', primeGlyph) : undefined
}
